/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConversioneDettaglioUpdateDTO
 */
export interface ConversioneDettaglioUpdateDTO {
    /**
     * 
     * @type {number}
     * @memberof ConversioneDettaglioUpdateDTO
     */
    indiceConversione?: number;
    /**
     * 
     * @type {number}
     * @memberof ConversioneDettaglioUpdateDTO
     */
    percentuale?: number;
}

/**
 * Check if a given object implements the ConversioneDettaglioUpdateDTO interface.
 */
export function instanceOfConversioneDettaglioUpdateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ConversioneDettaglioUpdateDTOFromJSON(json: any): ConversioneDettaglioUpdateDTO {
    return ConversioneDettaglioUpdateDTOFromJSONTyped(json, false);
}

export function ConversioneDettaglioUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversioneDettaglioUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'indiceConversione': !exists(json, 'indiceConversione') ? undefined : json['indiceConversione'],
        'percentuale': !exists(json, 'percentuale') ? undefined : json['percentuale'],
    };
}

export function ConversioneDettaglioUpdateDTOToJSON(value?: ConversioneDettaglioUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'indiceConversione': value.indiceConversione,
        'percentuale': value.percentuale,
    };
}

